<template>
  <CustomModal id="add-to-series-modal"
               class="basic-modal add-to-series-modal"
               v-bind:ok-disabled="saveDisabled"
               v-bind:ok-busy="busy"
               v-bind:ok-title="$t('common.save')"
               v-on:cancel="$emit('cancel')"
               v-on:ok="save()">
    <div class="add-to-series-modal__title" slot="modal-header">
      {{ $t('publishers.modal.add_to_series.title') }}
    </div>

    <div class="text-center" v-if="loading">
      <LoadingBounce></LoadingBounce>
      <div class="typography--body-2 typography--color-disabled pb-5">
        {{ $t('common.loading') }}
      </div>
    </div>

    <div class="add-to-series-modal__series-list scroll-box" v-else>
      <SeriesListItem
        v-for="seriesItem in seriesList"
        v-bind:key="seriesItem.id"
        v-bind:series-item="seriesItem"
        v-bind:is-active="selectedSeriesId === seriesItem.id"
        v-bind:selected-chapter-id="selectedChapterId"
        v-on:select-series="selectSeries"
        v-on:select-chapter="selectChapter"
      />

      <InfiniteLoading :on-infinite="onInfinite" ref="infiniteLoading" class="w-100">
        <div slot="spinner">
          <LoadingBounce></LoadingBounce>
          <div class="typography--body-2 typography--color-disabled pb-5">{{ $t('common.loading') }}</div>
        </div>

        <div slot="no-more" class="col-12 text-center mb-5 pb-5">
        </div>
      </InfiniteLoading>

    </div>
  </CustomModal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isNil } from 'lodash';
  import InfiniteLoading from 'vue-infinite-loading';
  import SeriesListItem from './SeriesListItem';

  export default {
    name: 'add-to-series-modal',

    components: {
      InfiniteLoading,
      SeriesListItem,
    },

    props: {
      seriesList: {
        type: Array,
        default: [],
      },
      publisherId: {
        type: Number,
        default: null,
      },
      cardIdForAddToSeries: {
        type: Number,
        default: null,
      },
    },

    data() {
      return {
        loading: false,
        busy: false,
        selectedSeriesId: null,
        selectedChapterId: null,
      };
    },

    computed: {
      ...mapGetters([
        'chapters',
        'series',
      ]),

      saveDisabled() {
        return (isNil(this.selectedSeriesId) || isNil(this.selectedChapterId));
      },
    },

    methods: {
      ...mapActions([
        'fetchPublisherSeries',
        'addCardToSeries',
      ]),

      selectSeries(seriesId) {
        this.selectedSeriesId = seriesId;
        this.selectedChapterId = null;
      },

      selectChapter(chapterId) {
        this.selectedChapterId = chapterId;
      },

      onInfinite() {
        const offset = parseInt(this.seriesList.length / 20, 10) * 20;
        const limit = 20;
        const params = {
          publisher_id: this.publisherId,
          offset,
          limit,
        };

        return this.fetchPublisherSeries(params)
          .then((seriesList) => {
            if (this.$refs.infiniteLoading) {
              this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

              if (seriesList.length < limit) {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
              }
            }
          });
      },

      save() {
        if (!this.busy && !isNil(this.cardIdForAddToSeries)) {
          this.busy = true;

          const selectedChapter = this.chapters[this.selectedChapterId];
          const selectedSeries = this.series[this.selectedSeriesId];
          const params = {
            card_id: this.cardIdForAddToSeries,
            series_id: this.selectedSeriesId,
            chapter_id: this.selectedChapterId,
          };

          if (!isNil(selectedSeries)) {
            params.subject_id = selectedSeries.subject_id;
            params.grade_id = selectedSeries.grade_id;
          }

          if (!isNil(selectedChapter)) {
            params.chapter_name = selectedChapter.name;
            params.chapter_position = selectedChapter.position;
            params.core_concept_id = selectedChapter.core_concept_id;
            params.unit_id = selectedChapter.unit_id;
          }
  
          this.addCardToSeries(params)
            .then(() => (
              this.$emit('ok')
            ));
        }
      },
    },

  };
</script>

<style lang="scss">
  .add-to-series-modal {
    .add-to-series-modal__series-list {
      max-height: 400px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/publishers/components/AddToSeriesModal.vue